export function urlFilter(value, type, scale = 50) {
  const reg = /http/;
  const file_url = 'https://file.wanduomi.com';
  if (reg.test(value)) return value;
  if (process.env.NODE_ENV == 'development') {
    // value = "http://psdfile-dev.b0.upaiyun.com" + "/" + value;
    if (
      value != null &&
      typeof value == 'string' &&
      value.substr(0, 1) == '/'
    ) {
      if (type === 'video') {
        value = file_url + '/' + value;
      } else {
        value = file_url + value + '!/scale/' + scale;
      }
    } else {
      value = file_url + '/' + value;
    }
  } else {
    if (
      value != null &&
      typeof value == 'string' &&
      value.substr(0, 1) == '/'
    ) {
      if (type === 'video') {
        value = file_url + '/' + value;
      } else {
        value = file_url + value + '!/scale/' + scale;
      }
    } else {
      value = file_url + '/' + value;
    }
  }
  return value;
}

export function formatDate(time) {
	var datetime = new Date(time);
	var year = datetime.getFullYear(),
			month = (datetime.getMonth() + 1 < 10) ? '0' + (datetime.getMonth() + 1):datetime.getMonth() + 1,
			day = datetime.getDate() < 10 ? '0' +  datetime.getDate() : datetime.getDate();
	return year + '-' + month + '-' + day ;
}

export function audioFilter(value, type, scale = 50) {
  const reg = /http/;
  const file_url = 'https://file.wanduomi.com';
  if (reg.test(value)) return value;
  value = file_url + value;
  return value;
}

export const dateFormatter = (nows) => {
  if (!nows) return '';
  var now = new Date(nows);
  var year = now.getFullYear();

  var month = now.getMonth() + 1;
  month = checkAddZone(month);

  var date = now.getDate();
  date = checkAddZone(date);
  return year + '-' + month + '-' + date;
};

function checkAddZone(num) {
  return num < 10 ? '0' + num.toString() : num;
}

export function dateTimeFormatter(t, type) {
  if (!t) return '';
  t = new Date(t).getTime();
  t = new Date(t);
  // var year = t.getFullYear()
  var month = t.getMonth() + 1;
  // month = checkAddZone(month)

  var date = t.getDate();
  // date = checkAddZone(date)

  var hour = t.getHours();
  hour = checkAddZone(hour);

  var min = t.getMinutes();
  min = checkAddZone(min);

  // var se = t.getSeconds()
  // se = checkAddZone(se)
  if (!type) {
    return month + '月' + date + '日' + hour + ':' + min;
  }
  if (type == 'm-d') {
    return month + '月' + date + '日';
  }
  if (type == 'h-m') {
    return hour + ':' + min;
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  // console.log((time+'').length)
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    // if (("" + time).length === 10) {
    //     time = parseInt(time) * 1000
    // } else {
    //     if (
    //         /Safari/.test(navigator.userAgent) &&
    //         !/Chrome/.test(navigator.userAgent) &&
    //         ("" + time).length != 10 &&
    //         ("" + time).length != 13
    //     ) {
    //         time = time.replace(/-/g, "/")
    //     }
    // }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a')
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function getSeconds(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  // console.log((time+'').length)
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    // if (("" + time).length === 10) {
    //     time = parseInt(time) * 1000
    // } else {
    //     if (
    //         /Safari/.test(navigator.userAgent) &&
    //         !/Chrome/.test(navigator.userAgent) &&
    //         ("" + time).length != 10 &&
    //         ("" + time).length != 13
    //     ) {
    //         time = time.replace(/-/g, "/")
    //     }
    // }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a')
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return formatObj.s;
}

export function timesOut(time, cFormat) {
  if (time <= 0) {
    return '00:00:00';
  }
  if (!time) {
    return '00:00:00';
  }
  var hour = parseInt(time / 1000 / 60 / 60);
  var sec =
    parseInt((time / 1000 / 60) % 60) > 10
      ? parseInt((time / 1000 / 60) % 60)
      : '0' + parseInt((time / 1000 / 60) % 60);
  var min =
    (time / 1000) % 60 > 10
      ? parseInt((time / 1000) % 60)
      : '0' + parseInt((time / 1000) % 60);
  var time_str = hour + ':' + sec + ':' + min;
  return time_str;
}

export function DateAdd(interval, number, date) {
  switch (interval) {
    case 'y': {
      date.setFullYear(date.getFullYear() + number);
      return date;
    }
    case 'q': {
      date.setMonth(date.getMonth() + number * 3);
      return date;
    }
    case 'm': {
      date.setMonth(date.getMonth() + number);
      return date;
    }
    case 'w': {
      date.setDate(date.getDate() + number * 7);
      return date;
    }
    case 'd': {
      date.setDate(date.getDate() + number);
      return date;
    }
    case 'h': {
      date.setHours(date.getHours() + number);
      return date;
    }
    case 'min': {
      date.setMinutes(date.getMinutes() + number);
      return date;
    }
    case 's': {
      date.setSeconds(date.getSeconds() + number);
      return date;
    }
    default: {
      date.setDate(date.getDate() + number);
      return date;
    }
  }
}

export function AddressParameter(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function deepClone(data) {
  var type = typeof data;
  var obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object' && data != null) {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
}
// 货币格式(截取小数点后两位)
export function moneyFormat(money) {
  if (money && money != null) {
    money = String(money);
    var left = money.split('.')[0],
      right = money.split('.')[1];
    right = right
      ? right.length >= 2
        ? '.' + right.substr(0, 2)
        : '.' + right + '0'
      : '.00';
    var temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g);
    return (
      (Number(money) < 0 ? '-' : '') +
      temp
        .join(',')
        .split('')
        .reverse()
        .join('') +
      right
    );
  } else {
    //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00';
  }
}

//   魅力值/豪气值处理
export function richsCharmsrule(value, list) {
  let data = '';
  if (value) {
    list.forEach((item, index) => {
      if (
        (item.price < value || item.price == value) &&
        value < list[index + 1].price
      ) {
        data = item.remark;
      }
    });
  }
  return data;
}

export function getCookie(cookie_name) {
  var allcookies = document.cookie;
  //索引长度，开始索引的位置
  var cookie_pos = allcookies.indexOf(cookie_name);

  // 如果找到了索引，就代表cookie存在,否则不存在
  if (cookie_pos != -1) {
    // 把cookie_pos放在值的开始，只要给值加1即可
    //计算取cookie值得开始索引，加的1为“=”
    cookie_pos = cookie_pos + cookie_name.length + 1;
    //计算取cookie值得结束索引
    var cookie_end = allcookies.indexOf(';', cookie_pos);

    if (cookie_end == -1) {
      cookie_end = allcookies.length;
    }
    //得到想要的cookie的值
    var value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}

// 充值跳转
export function recharge(appType) {
  // let ua = navigator.userAgent;
  // ios 直播间充值和活动页充值路由一样
  if (appType == 17) {
    // 朵蜜充值
    window.location.href = 'native://?module=User&action=gotoCoinRecharge&className=RechargeController&androidUrl=/user/account'
  } else {
    // 盘丝洞充值
    window.location.href = 'native://?action=gotoRecharge&module=User&androidUrl=/user/recharge'
  }
  // android 直播间充值需要调用方法
  // if(isLive == 1 && ua.indexOf("Android") > 0){
  //   window.webBridge.callAppRouter('showRechargeDialog')
  // }
}

export function goChat(userId) {
  window.location.href =
    "native://?className=PSMyDetailInfoController&androidUrl=/user/viewHomepage&userId=" +
    userId +
    "&change=1";
}

export function initCollect(eventName) {
  window.collectName = eventName
  let server = process.env.NODE_ENV;
  let appId = server == "production" ? 423183 : 430670  // 判断环境
  window.collectEvent('init', {
    app_id: appId, // 参考2.1节获取，注意类型是number而非字符串
    channel: 'cn', // 设置数据上送地址
    log: true, // true:开启日志，false:关闭日志
    autotrack: true, // 全埋点开关，true开启，false关闭
  });
  window.collectEvent('start'); // 发送数据
  let collectStore = {}
  if (localStorage.getItem("collectStore")) {
    collectStore = JSON.parse(localStorage.getItem("collectStore"))
    let newCollectStore = deepClone(collectStore)
    // 当天用户首次进入
    if (collectStore.page_first_day_join != parseTime(new Date().getTime(), "{y}-{m}-{d}")) {
      collectStore.page_first_day_join = parseTime(new Date().getTime(), "{y}-{m}-{d}")
      newCollectStore.page_first_day_join = collectStore.page_first_day_join
    } else {
      delete collectStore.page_first_day_join
      delete newCollectStore.page_first_day_join
    }
    localStorage.setItem("collectStore",JSON.stringify(newCollectStore))
  } else {
    collectStore = {
      page_first_day_join: parseTime(new Date().getTime(), "{y}-{m}-{d}"), // 当天首次进入
      page_first_join: parseTime(new Date().getTime(), "{y}-{m}-{d}"), // 是否首次进入
    }
    localStorage.setItem("collectStore",JSON.stringify(collectStore))
  }
  window.collectData = {
    page_duration: new Date().getTime(), // 停留时间参数
    page_url: location.origin + location.pathname, // 页面信息
    page_title: document.title, // 页面标题
    ...collectStore
  }
  // 配置用户是否首次进入
  // 监控是否进入后台
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState == "visible") {
      window.collectData = {
        page_duration: new Date().getTime(), // 停留时间参数
        page_url: location.origin + location.pathname, // 页面信息
        page_title: document.title, // 页面标题
        ...collectStore
      }
		}
    if (document.visibilityState == "hidden") {
      sendCollect(eventName);
		}
  })
  window.addEventListener("beforeunload", (e) => {
    window.collectEvent('beconEvent', eventName, window.collectData)
  });
}

export function sendCollect(eventName) {
  window.collectData.page_duration = (new Date().getTime() - window.collectData.page_duration) / 1000
  window.collectEvent(eventName, window.collectData)
}
// data 传输对象 isExit是否离开
export function sendSelfCollect(data, isExit = false) {
  if (isExit) {
    window.collectEvent('beconEvent', window.collectName, data)
  } else {
    window.collectEvent(window.collectName, data)
  }
}
// 判断是移动端还是pc端
export function IsPC () {
	var userAgentInfo = navigator.userAgent;
	var Agents = ["Android", "iPhone",
		"SymbianOS", "Windows Phone",
		"iPad", "iPod"];
	for (var v = 0; v < Agents.length; v++) {
		if (userAgentInfo.indexOf(Agents[v]) > 0) {
			this.flagPc = false;
			break;
		}
	}
	console.log(this.flagPc);
}